import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["size", "circular", "src", "position"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { AvatarPlaceholder } from '@mediahuis/chameleon-theme-wl/illustrations';
import system from '../../system';
import Box from '../Box';
import styles from './index.module.scss';
var SYSTEM_PROPS = ['marginProps', 'positioningProps', 'floatProps'];
var Avatar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classNames;

  var size = _ref.size,
      circular = _ref.circular,
      src = _ref.src,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'relative' : _ref$position,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(_extends({}, props, {
    position: position
  }), SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  var classNames = (_classNames = {}, _classNames[styles.root] = true, _classNames[styles.small] = size === 'small', _classNames[styles.medium] = size === 'medium', _classNames[styles.large] = size === 'large', _classNames[styles.xLarge] = size === 'xLarge', _classNames[styles.circular] = circular, _classNames[styles.square] = !circular, _classNames);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: cx(classNames, className),
    style: style,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    as: AvatarPlaceholder,
    className: styles.inner
  }), src && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    className: styles.inner,
    style: {
      backgroundImage: "url(" + src + ")"
    }
  }));
});
Avatar.displayName = 'Avatar';
Avatar.identifier = Avatar.displayName;
Avatar.clonableProps = SYSTEM_PROPS;
Avatar.defaultProps = {
  circular: false,
  size: 'medium'
};
export default Avatar;